import { defineStore } from 'pinia'
import Actions from './actions'
import { useState } from './state'

export { type RailState } from './state'

export const useRailStore = defineStore('rail', {
  state: useState,
  actions: { ...Actions },
})

export type RailStoreContext = ReturnType<typeof useRailStore>